import { render, staticRenderFns } from "./TableActions.vue?vue&type=template&id=9f220dda&"
import script from "./TableActions.vue?vue&type=script&lang=js&"
export * from "./TableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports